import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const PublicRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Si l'utilisateur est connecté, rediriger vers la page d'accueil authentifiée
  if (user) {
    return <Navigate to="/home" replace />;
  }

  // Si l'utilisateur n'est pas connecté, afficher le contenu public
  return children;
};

export default PublicRoute;